import { createContext, useContext, useReducer } from 'react';
import { FETCH_GPU_CLASSES } from '@/actions/types';

const GpuClassesContext = createContext(null);
const GpuClassesDispatchContext = createContext(null);

const initialState = null;

function gpuClassesReducer(state, action) {
  switch (action.type) {
    case FETCH_GPU_CLASSES: {
      return action.payload;
    }
    default: {
      throw Error('Unknown action: ' + action.type);
    }
  }
}

export function GpuClassesProvider({ children }) {
  const [gpuClasses, dispatch] = useReducer(gpuClassesReducer, initialState);

  return (
    <GpuClassesContext.Provider value={gpuClasses}>
      <GpuClassesDispatchContext.Provider value={dispatch}>
        {children}
      </GpuClassesDispatchContext.Provider>
    </GpuClassesContext.Provider>
  );
}

export function useGpuClasses() {
  return useContext(GpuClassesContext);
}

export function useGpuClassesDispatch() {
  const dispatch = useContext(GpuClassesDispatchContext);
  if (!dispatch) {
    throw new Error('useGpuClassesDispatch must be used within GpuClassesProvider');
  }
  return dispatch;
}
